export default __webpack_public_path__ + "static/media/resume-sec.4d367309.pdf";